export enum ProcessInfoStatus {
  Started = 'started',
  Completed = 'completed'
}
